import React from "react"
import styled from "styled-components"
import { Headline } from "../../../utils"
import { AosWrapper } from "../../molecules/AosWrapper"

export interface IQuoteComponent {
  quote: string
  quoteMaster: string
}

const Wrapper = styled.div`
  padding: 80px 20px;
  background: ${(props) => props.theme.quoteGradientBackground};
  .quote-svg {
    position: absolute;
    width: 85px;
    height: 60px;
    object-fit: contain;
    @media (max-width: 786px) {
      width: 43px;
      height: 31px;
    }
  }
  .non-reverse-img {
    left: 14%;
    transform: rotate(180deg);
    transform: scaleY(-1);
    @media (max-width: 786px) {
      left: 0;
    }
  }
  .reverse-img {
    transform: rotate(180deg);
    bottom: 0px;
    right: 14%;
    @media (max-width: 786px) {
      right: 15%;
    }
  }
  @media (max-width: 1023px) {
    padding: 50px 60px;
  }
  @media (max-width: 600px) {
    padding: 40px 20px;
  }
`
const Content = styled.div`
  position: relative;
  max-width: 1500px;
  margin: auto;
`
const Quote = styled(Headline)`
  color: ${(props) => props.theme.sameTextColor};
  font-size: 2.25rem;
  margin-bottom: 10px;
  line-height: 54px;
  font-weight: 600;
  text-align: center;
  white-space: break-spaces;
  @media (max-width: 1023px) {
    font-size: 1.5rem;
    line-height: 36px;
  }
  @media (max-width: 600px) {
    font-size: 1.25rem;
    line-height: 30px;
  }
`

const QuoteMaster = styled.div`
  ${(props) => props.theme.typography.quoteWriter}
  color: ${(props) => props.theme.sameTextColor};
  font-family: Lato, sans-serif;
  text-align: center;
  font-size: 1.375rem;
  font-weight: normal;
  line-height: 34px;
  @media (max-width: 600px) {
    font-size: 0.875rem;
    line-height: 22px;
  }
`

const QuoteComponent: React.FC<IQuoteComponent> = ({ quote, quoteMaster }) => {
  return (
    <Wrapper>
      <Content>
        <img
          src={"/assets/icons/quote.svg"}
          className={"quote-svg non-reverse-img"}
        />
        <AosWrapper>
          <Quote>{quote}</Quote>
          <QuoteMaster>{`- ${quoteMaster}`}</QuoteMaster>
        </AosWrapper>
        <img
          src={"/assets/icons/quote.svg"}
          className={"quote-svg reverse-img"}
        />
      </Content>
    </Wrapper>
  )
}

export { QuoteComponent }
